import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import Technical from './Technical'
import Fundamental from './Fundamental'
import Sentiment from './Sentiment'
import Compare from './Compare'

import style from './style.sass'

@inject('store') @observer
class Indicators extends Component {
  render() {
    const {has_coins} = this.props.store.analysis
    return(
      <div styleName='wrapper'>
        <div>
          <Technical/>
        </div>
        {!has_coins
          ?
          <div>
            <Fundamental/>
          </div>
          : false
        }
        <div>
          <Sentiment/>
        </div>
        <div>
          <Compare/>
        </div>
      </div>
    )
  }
}

export default Indicators
